import Fetch from './Fetch';
import { apiURL } from '../constants';

class EnumsService {
  constructor() {
    this.cachedEnums = null;
  }

  getEnums() {
    if (this.cachedEnums) {
      return new Promise(resolve => resolve(this.cachedEnums));
    }

    return Fetch.getJSON(apiURL.API_ENUMS).then(response => {
      this.cachedEnums = {};

      // sort all enums
      Object.keys(response).forEach(key => {
        const lowerKey = key.charAt(0).toLowerCase() + key.slice(1);
        if (Array.isArray(response[key])) {
          this.cachedEnums[lowerKey] = response[key].sort((a, b) => {
            const titleA = a.title.toLowerCase();
            const titleB = b.title.toLowerCase();
            if (titleA < titleB) {
              return -1;
            }

            if (titleA > titleB) {
              return 1;
            }

            return 0;
          });
        } else {
          this.cachedEnums[lowerKey] = response[key];
        }
      });

      return this.cachedEnums;
    });
  }
}

export default new EnumsService();